export const setDetail = ( state, detail ) => {
    state.detail = detail
}

export const setFavorites = ( state, favorites ) => {
    state.favorites = favorites
}
